import { all, takeEvery, call, put } from 'redux-saga/effects'
import { FETCH_UNREAD_COUNT, setUnreadCount } from '../../notifications'
import apiServerApi from '../apiServerApi'
import store from "store"
import { FIVE_MINUTES_MS } from '../../../lib/utils'

const UNREAD_COUNT_KEY = "notificationsUnreadCountLastFetch"

function* fetchUnreadCountSaga(action) {

  try {

    const force = action && action.payload && action.payload.force,
    last = Number(localStorage.getItem(UNREAD_COUNT_KEY) || 0),
    now = Date.now()

    if (!force && last && (now - last) < FIVE_MINUTES_MS) {
      return
    }

    const state = store.get("sessionData"),
    resp = (yield call(apiServerApi.countUnreadNotifications, state.access_token))

    if (resp) {
      const count = Number(resp.body || 0)
      yield put(setUnreadCount(count))
      localStorage.setItem(UNREAD_COUNT_KEY, String(Date.now()))
    }
  }
  catch (e) {
    console.error('fetchUnreadCountSaga error', e)
  }
}

function* NotificationsSaga() {
  yield all([
    takeEvery(FETCH_UNREAD_COUNT, fetchUnreadCountSaga),
  ])
}

export default NotificationsSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/notifications.js